import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import SessionTypeFormatter from "../../../Components/Reusable/List/SessionTypeFormatter";
import { prettyFormattedDateTimeFromISO } from "../../../Helpers/datetimeHelper";
import { PAGE_SIZE_OPTIONS } from "../../../Constants/FieldOptions";

function OrgActivitiesListMobile(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
  } = props;
  return (
    <>
      {listData &&
        listData.length > 0 &&
        listData.map(function (datum, i) {
          return (
            <div class="mb-5">
              <hr />
              <strong>ID:</strong>&nbsp;{datum.id}
              <br />
              <br />
              <strong>Name:</strong>&nbsp;{datum.name}
              <br />
              <br />
              <strong>No #:</strong>&nbsp;{datum.no}
              <br />
              <br />
              <strong>Session Type:</strong>&nbsp;
              <SessionTypeFormatter sessionType={datum.sessionType} />
              <br />
              <br />
              <strong>Completed:</strong>&nbsp;
              {datum.completedTime
                ? prettyFormattedDateTimeFromISO(datum.completedTime)
                : "N/a"}
              <br />
              <br />
              {/* Tablet only */}
              <div class="is-hidden-mobile pt-2">
                <div className="buttons is-right">
                  <Link
                    to={`/user/${datum.userId}/session/${datum.id}`}
                    class="button is-small is-primary"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faEye} />
                    &nbsp;View
                  </Link>
                </div>
              </div>
              {/* Mobile only */}
              <div class="is-hidden-tablet pt-2">
                <div class="columns is-mobile">
                  <div class="column">
                    <Link
                      to={`/user/${datum.userId}/session/${datum.id}`}
                      class="button is-small is-primary is-fullwidth"
                      type="button"
                    >
                      <FontAwesomeIcon className="mdi" icon={faEye} />
                      &nbsp;View
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      <div class="columns pt-4 is-multiline">
        <div class="column is-half">
          <span class="select">
            <select
              class={`input has-text-grey-light`}
              name="pageSize"
              onChange={(e) => setPageSize(parseInt(e.target.value))}
            >
              {PAGE_SIZE_OPTIONS.map(function (option, i) {
                return (
                  <option
                    selected={pageSize === option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                );
              })}
            </select>
          </span>
        </div>
        <div class="column is-half has-text-right">
          {previousCursors.length > 0 && (
            <button class="button" onClick={onPreviousClicked}>
              Previous
            </button>
          )}
          {listData.hasNextPage && (
            <>
              <button class="button" onClick={onNextClicked}>
                Next
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default OrgActivitiesListMobile;
